import Vue from 'vue'

export default {
  getters: {
    getMapMeta: state => value =>{
      if (state.modelMapper[value])
        return state.modelMapper[value].meta
    },
    getMapModel: state => value => {
      if (state.modelMapper[value])
        return state.modelMapper[value].model
    },
    getMapModels: state => value =>{
      if (state.modelMapper[value])
        return state.modelMapper[value].models
    }
  },
  mutations: {
    clearModelMapper(state) {
      state.modelMapper = {}
    },
    mapMeta(state, { resource, meta }) {
      mapValue(state, { attribute: 'meta', resource: resource, value: meta })
    },
    mapModel(state, { resource, model }) {
      mapValue(state, { attribute: 'model', resource: resource, value: model })
    },
    mapModels(state, { resource, models }) {
      mapValue(state, { attribute: 'models', resource: resource, value: models })
    }
  },
  state: {
    modelMapper: {}
  }
}

function mapValue(state, { resource, attribute, value }) {
  if (!resource)
    throw new Error('Please provide resource')

  if (!state.modelMapper[resource])
    Vue.set(state.modelMapper, resource, {})
  Vue.set(state.modelMapper[resource], attribute, value)
}
